import { MatDialogRef } from '@angular/material/dialog'
import { fromEvent, Observable } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'

export function escapeKey$(
  dialogRef: MatDialogRef<unknown>,
  target: Document | HTMLElement = document,
): Observable<KeyboardEvent> {
  return fromEvent<KeyboardEvent>(target, 'keydown').pipe(
    filter((e) => e.key === 'Escape'),
    takeUntil(dialogRef.afterClosed()),
  )
}
